import styled from "styled-components";

export const ContainerPagina = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FormFiltros = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  justify-content: left;

  div {
    display: flex;
    margin-bottom: 5px;
    margin-top: 5px;
    width: 75%;
    column-gap: 15px;

    label {
      min-width: 350px;
    }

    @media only screen and (max-width: 1200px) {
      &.filtros {
        flex-direction: column;
        width: 95%;
      }
      &.botoes {
        flex-direction: row;
      }
    }
  }
`;

export const TabelaConteudo = styled.table`
  display: block;
  width: 780px;
  margin: 15px auto 0;
  padding: 4px 0 10px;
  border: 1px solid black;
  overflow-x: scroll;

  #principal {
    width: 780px;
  }

  &.print {
    margin: 5px 0;
    zoom: 90%;
  }

  .colunasTotal {
    grid-template-columns: 65% 22.5% 12.5%;

    td {
      font-weight: bolder;
      text-align: right;

      &:first-child {
        text-align: left;
      }
    }
  }

  table tbody {
    .cabecalhoTabelaSecao {
      display: flex;
      grid-template-columns: none;
      align-items: center;
      justify-content: center;
      padding: 2px;
      border: 1px solid black;
      border-bottom: none;
      background-color: ${({ theme }) => theme.colors.secundaria};
      font-weight: bold;

      td {
        border: none;
        padding: 0;
      }
    }

    .cabecalhoTabela {
      background-color: ${({ theme }) => theme.colors.secundaria};
      display: flex;
      grid-template-columns: none;

      td {
        font-weight: bold;
        text-align: left;
        padding: 2px 4px;
        border: 1px solid black;
        border-bottom: none;
        width: 100%;
      }
    }

    .colunasDescricao td {
      font-weight: bolder;
      border-top: 1px solid black;
    }

    .colunasDescricaoResumo {
      grid-template-columns: 20% 20% 20% 20% 20%;

      td {
        font-weight: bolder;
        border-top: 1px solid black;
        border-bottom: none;
      }
    }
  }
`;

export const AreaData = styled.table`
  width: 730px;
  margin: 4px auto 0;
  padding: 2px;
  border-bottom: 1px solid black;
`;

export const AreaInfo = styled.table`
  width: 750px;
  margin: 10px auto;
  padding: 2px;

  tr {
    display: flex;

    td {
      flex: 1;

      &.containerInfos {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        span {
          text-align: right;
          line-height: 17px;

          * {
            font-size: 16px;
          }
        }
      }
    }

    &.dadosCooperativa {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px;

      td {
        font-weight: bold;
        text-align: center;
        padding-top: 15px;
      }
    }
  }

  img {
    height: 95px;
  }
`;

export const AreaCooperado = styled.table`
  width: 750px;
  margin: 5px auto 0;

  tr {
    display: grid;
    grid-template-columns: 75% 25%;

    td {
      padding: 10px;

      :nth-child(2) {
        text-align: right;
      }

      * {
        font-size: 13px;
        line-height: 14px;
      }
    }
  }
`;

export const Demonstrativo = styled.div`
  width: 750px;
  margin: 5px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.secundaria};
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
`;

export const ProducaoRepasseTabela = styled.table`
  width: 750px;
  margin: 5px auto 0;

  tr {
    display: grid;
    grid-template-columns: 50% 50%;

    &:last-child {
      border-bottom: 1px solid black;
    }

    td {
      border: 1px solid black;
      border-bottom: none;
      padding: 2px 4px;

      &.destaque {
        font-weight: bold;
      }
      & + td {
        border-left: none;
        text-align: right;
      }
    }
  }
`;

export const LinhasTabelaProdutividade = styled.table`
  width: 750px;
  margin: 4px auto;

  tr {
    display: grid;
    grid-template-columns: 17% 22% 22% 22% 17%;

    &.colunasTotal {
      grid-template-columns: 61% 22% 17%;
    }

    td {
      text-align: center;
      padding: 2px 4px;
      font-size: 12px;
      border: 1px solid black;
      border-top: none;

      & + td {
        border-left: none;
      }
      * {
        font-size: 12px;
      }
    }
  }
`;

export const LinhasTabelaProcedimentos = styled.table`
  width: 750px;
  margin: 4px auto;

  tr {
    display: grid;
    grid-template-columns: 10% 16% 16% 18% 20% 10% 10%;

    &.colunasTotal {
      grid-template-columns: 60% 20% 10% 10%;
    }

    td {
      text-align: center;
      padding: 2px 4px;
      font-size: 12px;
      border: 1px solid black;
      border-top: none;

      & + td {
        border-left: none;
      }
      * {
        font-size: 12px;
      }
    }
  }
`;

export const LinhasTabela = styled.table`
  width: 750px;
  margin: 4px auto;

  tr {
    display: grid;
    grid-template-columns: 11% 17% 19% 15% 10% 6.25% 6.25% 8% 7.5%;

    &.colunasTotal {
      grid-template-columns: 62% 22.5% 15.5%;
    }
    td {
      text-align: center;
      padding: 2px 4px;
      font-size: 12px;
      border: 1px solid black;
      border-top: none;

      & + td {
        border-left: none;
      }
      * {
        font-size: 12px;
      }
    }
  }
`;

export const LinhasTabelaProducoes = styled.table`
  width: 750px;
  margin: 4px auto;

  tr#tabelaMista {
    display: table-row;
    grid-template-columns: none;
    border: none;
    padding: none;
  }

  tr {
    min-width: 100%;
    display: grid;
    grid-template-columns: 11% 11% 10% 6% 9% 6% 9% 6% 9% 6% 9% 8%;

    &.colunasDescricao {
      display: table-row;
      grid-template-columns: none;

      td.hrValor {
        border-top: none;
        border-left: none;
      }
    }

    &.colunasTotal {
      display: grid;
      grid-template-columns: 32% 6% 9% 6% 9% 6% 9% 6% 9% 8%;

      td:first-child {
        text-align: right;
      }
      td {
        text-align: center;
      }
    }

    td {
      text-align: center;
      padding: 2px 4px;
      font-size: 11px;
      border: 1px solid black;
      border-top: none;

      & + td {
        border-left: none;
      }
      * {
        font-size: 11px;
      }
    }
  }
`;

export const LinhasTabelaDetalhamentos = styled.table`
  width: 750px;
  margin: 4px auto;
  tr {
    display: grid;
    grid-template-columns: 18% 12% 16% 16% 11% 5% 12% 10%;

    td {
      text-align: center;
      padding: 2px 4px;
      font-size: 12px;
      border: 1px solid black;
      border-top: none;

      & + td {
        border-left: none;
      }
      * {
        font-size: 12px;
      }
    }

    &.colunasTotal {
      grid-template-columns: 62% 16% 22%;
    }
  }
`;

export const LinhasTabelaResumo = styled.table`
  width: 750px;
  margin: 4px auto;

  tr {
    display: grid;
    grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;

    td {
      text-align: center;
      padding: 2px 4px;
      font-size: 12px;
      border: 1px solid black;
      border-top: none;

      & + td {
        border-left: none;
      }
      * {
        font-size: 12px;
      }
    }
  }
`;
